var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleCheckRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3066_52915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3335 1.5C10.0574 1.5 11.7107 2.18482 12.9297 3.40381C14.1487 4.62279 14.8335 6.27609 14.8335 8C14.8335 9.72391 14.1487 11.3772 12.9297 12.5962C11.7107 13.8152 10.0574 14.5 8.3335 14.5C6.60959 14.5 4.95629 13.8152 3.7373 12.5962C2.51832 11.3772 1.8335 9.72391 1.8335 8C1.8335 6.27609 2.51832 4.62279 3.7373 3.40381C4.95629 2.18482 6.60959 1.5 8.3335 1.5ZM8.3335 16C10.4552 16 12.4901 15.1571 13.9904 13.6569C15.4906 12.1566 16.3335 10.1217 16.3335 8C16.3335 5.87827 15.4906 3.84344 13.9904 2.34315C12.4901 0.842855 10.4552 0 8.3335 0C6.21176 0 4.17693 0.842855 2.67664 2.34315C1.17635 3.84344 0.333496 5.87827 0.333496 8C0.333496 10.1217 1.17635 12.1566 2.67664 13.6569C4.17693 15.1571 6.21176 16 8.3335 16ZM11.8647 6.53125C12.1585 6.2375 12.1585 5.7625 11.8647 5.47188C11.571 5.18125 11.096 5.17813 10.8054 5.47188L7.33662 8.94063L5.86787 7.47188C5.57412 7.17813 5.09912 7.17813 4.8085 7.47188C4.51787 7.76562 4.51475 8.24063 4.8085 8.53125L6.8085 10.5312C7.10225 10.825 7.57725 10.825 7.86787 10.5312L11.8647 6.53125Z",
    fill: "#BBC2C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3066_52915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckRegular);
export default __webpack_public_path__ + "static/media/circle-check-regular.96349fb400c976370f1d8491e1a70b9a.svg";
export { ForwardRef as ReactComponent };